<template>
  <div
    :class="[`icon--${name}`, `icon--${size}`, { 'has-align-fix': fixAlign }]"
    class="icon"
  >
    <font-awesome-icon
      :icon="iconName"
      class="font-awesome-icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'normal',
    },
    modifier: {
      type: String,
      default: null,
    },
    fixAlign: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    iconName() {
      switch (this.name) {
        case 'ul':
          return 'list-ul'
        case 'ol':
          return 'list-ol'
        case 'hr':
          return 'grip-lines'
        default:
          return this.name
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.icon {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 0.8rem;
  height: 0.8rem;
  margin: 0 0.3rem;
  top: -0.05rem;
  fill: currentColor;
  &__svg {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: 100%;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
}
// svg sprite
body > svg,
.icon use > svg,
symbol {
  path,
  rect,
  circle,
  g {
    fill: currentColor;
    stroke: none;
  }
  *[d='M0 0h24v24H0z'] {
    display: none;
  }
}
</style>
